import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { tarifasAnualesAPI } from '../../services/api';

const initialState = {
  tariffs: [],
  loading: false,
  error: null
};

export const fetchTarifas = createAsyncThunk(
  'tarifasAnuales/fetchTarifas',
  async (_, { rejectWithValue }) => {
    try {
      const response = await tarifasAnualesAPI.getAll();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createTarifa = createAsyncThunk(
  'tarifasAnuales/createTarifa',
  async (tarifaData, { rejectWithValue }) => {
    try {
      const response = await tarifasAnualesAPI.create(tarifaData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateTarifa = createAsyncThunk(
  'tarifasAnuales/updateTarifa',
  async ({ id, tarifaData }, { rejectWithValue }) => {
    try {
      const response = await tarifasAnualesAPI.update(id, tarifaData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTarifa = createAsyncThunk(
  'tarifasAnuales/deleteTarifa',
  async (id, { rejectWithValue }) => {
    try {
      await tarifasAnualesAPI.delete(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const tarifasAnualesSlice = createSlice({
  name: 'tarifasAnuales',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTarifas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTarifas.fulfilled, (state, action) => {
        state.loading = false;
        state.tariffs = action.payload;
      })
      .addCase(fetchTarifas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTarifa.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTarifa.fulfilled, (state, action) => {
        state.loading = false;
        state.tariffs.push(action.payload);
      })
      .addCase(createTarifa.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTarifa.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTarifa.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.tariffs.findIndex(t => t.id === action.payload.id);
        if (index !== -1) {
          state.tariffs[index] = action.payload;
        }
      })
      .addCase(updateTarifa.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteTarifa.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTarifa.fulfilled, (state, action) => {
        state.loading = false;
        state.tariffs = state.tariffs.filter(t => t.id !== action.payload);
      })
      .addCase(deleteTarifa.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const selectTarifas = (state) => state.tarifasAnuales.tariffs;
export const selectTarifasLoading = (state) => state.tarifasAnuales.loading;
export const selectTarifasError = (state) => state.tarifasAnuales.error;

export const selectTarifasByCategoria = (state) => {
  const tariffs = state.tarifasAnuales.tariffs;
  const grouped = {};
  
  tariffs.forEach(tariff => {
    if (!grouped[tariff.categoria]) {
      grouped[tariff.categoria] = [];
    }
    grouped[tariff.categoria].push(tariff);
  });
  
  return grouped;
};

export const { clearError } = tarifasAnualesSlice.actions;
export default tarifasAnualesSlice.reducer;
